import { Validators } from "@angular/forms";
import { ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants";

export const divestment_form_template = {
    amount: 0
}

export const divestment_form_validators = {
    amount: [Validators.required, Validators.pattern(/^\d+(\,\d+)?$/)]
}

export const DIVESTMENT_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
    {
        key: 'description',
        label: 'Nome fondo'
    },
    {
        key: 'fundAmount',
        label: 'Importo fondo (€)'
    },
    {
        key: 'amount',
        label: 'Importo da disinvestire (€)'
    }
]